import { createAsyncThunk } from '@reduxjs/toolkit';
import { getChannelHistory } from 'services/smsConversations';
import { ISmsChannelHistory } from 'services/smsConversations/types';

export const ThunkGetSmsChannelHistory = createAsyncThunk<ISmsChannelHistory[], number>(
  'pod/getChannelHistory',
  async channelId => {
    const r = await getChannelHistory(channelId);
    return r.data;
  },
);
